import axios from "axios";

//const
const EQUIPMENT_BACKUP_CONFIG_UPDATE_DATA = "equipmentBackupConfig/EQUIPMENT_BACKUP_CONFIG_UPDATE_DATA";
const EQUIPMENT_BACKUP_CONFIG_STORE_NODE = "equipmentBackupConfig/EQUIPMENT_BACKUP_CONFIG_STORE_NODE";
const EQUIPMENT_BACKUP_CONFIG_TOGGLE_MODAL = "equipmentBackupConfig/EQUIPMENT_BACKUP_CONFIG_TOGGLE_MODAL";
const EQUIPMENT_BACKUP_CONFIG_TOGGLE_LOADING = "equipmentBackupConfig/EQUIPMENT_BACKUP_CONFIG_TOGGLE_LOADING";

// modal const
export const EQUIPMENT_BACKUP_CONFIG_SUCCESS_TITLE = "scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_success_title";
export const EQUIPMENT_BACKUP_CONFIG_FAIL_TITLE = "scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_fail_title";
export const EQUIPMENT_BACKUP_CONFIG_SUBMIT_SUCCESS_CONTENT = "scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_submitSuccess_content";
export const EQUIPMENT_BACKUP_CONFIG_SUBMIT_FAIL_CONTENT = "scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_submitFail_content";
export const EQUIPMENT_BACKUP_CONFIG_OK_LABEL = "scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_OK_label";
export const EQUIPMENT_BACKUP_CONFIG_CANCEL_LABEL = "scenes_Equipment_EquipmentBackup_EquipmentBackupConfig_modal_cancel_label";

//reducer
export const equipmentBackupConfig = (state = {
  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  equipmentId: "",
  equipmentNode: [],
}, action) => {
  switch (action.type) {
    case EQUIPMENT_BACKUP_CONFIG_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_BACKUP_CONFIG_STORE_NODE:
      return {
        ...state,
        equipmentNode: action.data.collectNodeConfigs.map(d => {
          d.equipmentConfig = {id: action.data.id};
          return d;
        })
      };
    case EQUIPMENT_BACKUP_CONFIG_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case EQUIPMENT_BACKUP_CONFIG_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateEquipmentBackupConfigData = (data) => {
  return {
    type: EQUIPMENT_BACKUP_CONFIG_UPDATE_DATA,
    data: data
  }
};

/**
 * check and init equipment data
 */
export const initEquipmentBackupConfig = (equipmentId) => (dispatch) => {
  if (equipmentId !== null && equipmentId !== undefined && equipmentId !== "") {
    dispatch(updateEquipmentBackupConfigData({
      name: "equipmentId",
      value: equipmentId
    }));
    dispatch(toggleLoading(true));
    axios.get(`/api-equipment/getEquipmentConfigByEquipmentId/${equipmentId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeEquipmentNode(response.data));
        }
        dispatch(toggleLoading(false));
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

/**
 * store all equipment node
 */
export const storeEquipmentNode = (equipmentNode) => {
  return {
    type: EQUIPMENT_BACKUP_CONFIG_STORE_NODE,
    data: equipmentNode
  }
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: EQUIPMENT_BACKUP_CONFIG_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_BACKUP_CONFIG_TOGGLE_LOADING,
    data: show
  }
};

